var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{style:({
      'padding-top':
        _vm.$vuetify.breakpoint.name == 'xs'
          ? '10px'
          : _vm.$vuetify.breakpoint.name == 'sm'
          ? '150px'
          : _vm.$vuetify.breakpoint.name == 'md'
          ? '150px'
          : _vm.$vuetify.breakpoint.name == 'lg'
          ? '150px'
          : '150px',
    }),attrs:{"flat":""}},[_c('v-carousel',{attrs:{"continuous":"","cycle":"","interval":_vm.slideInterval,"show-arrows-on-hover":"","hide-delimiter-background":"","delimiter-icon":"mdi-minus","height":_vm.sliderHeight},model:{value:(_vm.slideNo),callback:function ($$v) {_vm.slideNo=$$v},expression:"slideNo"}},_vm._l((_vm.imageArray),function(item,i){return _c('v-carousel-item',{key:i},[_c('v-card',{attrs:{"flat":""}},[_c('v-img',{attrs:{"lazy-src":item.img,"src":item.img,"width":"100%","alt":item.img,"eager":""}})],1)],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }